// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.4033 5.06068L16.9389 8.59622L22.5957 2.93936L21.1815 1.52515L16.9389 5.76779L14.8175 3.64647L13.4033 5.06068Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.5 5C12.5 4.29442 12.6329 3.61987 12.8749 3H4V22.9432L12 17.2289L20 22.9432V10.1251C19.3801 10.3671 18.7056 10.5 18 10.5C14.9624 10.5 12.5 8.03757 12.5 5Z"}}]};

const BookmarkCheckedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'bookmark-checked-filled',
    ref,
    icon: element,
  },
));

BookmarkCheckedFilledIcon.displayName = 'BookmarkCheckedFilledIcon';

export default BookmarkCheckedFilledIcon;
